import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { AiSearchIcon } from 'foundations-assets/icons/components/AiSearchIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import styled from 'foundations-theming/utils';
import { breakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
/* Reduce padding and expand purchase motions wrapper at narrow viewports. */
const InfoRoot = styled.div.withConfig({
  displayName: "PublicAeoProductInfo__InfoRoot"
})(({
  theme
}) => ({
  flex: 1,
  backgroundColor: 'var(--fill-surface-default)',
  padding: theme.space['800'],
  [breakpoint.tablet]: {
    padding: theme.space['500']
  }
}));
const MotionsWrapper = styled.div.withConfig({
  displayName: "PublicAeoProductInfo__MotionsWrapper"
})({
  flexShrink: 0,
  inlineSize: '351px',
  [breakpoint.tablet]: {
    inlineSize: '100%'
  }
});
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { SingleSkeletonLoader } from 'pricing-pages-ui-components/loading/SingleSkeletonLoader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PriceSection = ({
  price,
  currencyCode,
  loading
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40,
      width: 175
    });
  }
  if (typeof price !== 'number') {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "175px"
    });
  }
  return /*#__PURE__*/_jsx(PricePerMonth, {
    price: price,
    currencyCode: currencyCode,
    showPricePerMonthPerSeat: false,
    seleniumId: "aeo-standalone"
  });
};
export const PublicAeoProductInfo = ({
  monthlyPrice,
  annualPrice,
  currencyCode,
  priceLoading,
  purchaseMotions,
  aeoProductUrl,
  onLearnMoreClick
}) => /*#__PURE__*/_jsxs(InfoRoot, {
  children: [/*#__PURE__*/_jsxs(Flex, {
    marginBlockEnd: "500",
    flexDirection: "row",
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.aeoPromoCard.title"
      })
    }), /*#__PURE__*/_jsx(AiSearchIcon, {
      size: "600"
    }), /*#__PURE__*/_jsx(Flex, {
      backgroundColor: "fill-accent-orange-subtle",
      borderRadius: "full",
      alignItems: "center",
      paddingBlock: "0",
      paddingInline: "200",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.aeoPromoCard.newBadge"
        })
      })
    })]
  }), /*#__PURE__*/_jsx(Text, {
    marginBlockEnd: "100",
    typography: "body-125",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.aeoPromoCard.subtitle"
    })
  }), /*#__PURE__*/_jsx(Text, {
    marginBlockEnd: "600",
    typography: "body-100",
    paddingInlineEnd: "700",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.aeoPromoCard.description"
    })
  }), /*#__PURE__*/_jsx(Text, {
    as: "div",
    typography: "heading-400",
    children: /*#__PURE__*/_jsx(PriceSection, {
      price: monthlyPrice,
      currencyCode: currencyCode,
      loading: priceLoading
    })
  }), /*#__PURE__*/_jsx(Text, {
    marginBlockEnd: "300",
    typography: "body-100",
    color: "text-core-subtle",
    as: "div",
    children: priceLoading ? /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 16,
      width: 200
    }) : typeof annualPrice === 'number' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "publicPricingPage.aeoPromoCard.annualPrice",
      options: {
        price: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "priceComponents.pricePerMonth",
          options: {
            price: /*#__PURE__*/_jsx(PriceDisplay, {
              price: annualPrice,
              currencyCode: currencyCode,
              dataSelenium: "aeo-standalone-annual-price"
            })
          }
        })
      }
    }) : null
  }), /*#__PURE__*/_jsx(Text, {
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.aeoPromoCard.includedLimits"
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "start",
    marginBlockEnd: "300",
    gap: "200",
    children: [/*#__PURE__*/_jsx(MotionsWrapper, {
      children: purchaseMotions
    }), /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      paddingBlockStart: "200",
      paddingInlineEnd: "800",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.aeoPromoCard.noAdditionalSubscription"
      })
    })]
  }), /*#__PURE__*/_jsx(Link, {
    href: aeoProductUrl,
    external: true,
    onClick: onLearnMoreClick,
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-25",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.aeoPromoCard.learnAboutAeo"
      })
    })
  })]
});